
const getLanguages = function () {
    return {
        'es' : 'Español',
        'en' : 'Inglés',
        'fr' : 'Francés',
        'de' : 'Alemán',
        'it' : 'Italiano',
        'pt' : 'Portugués',
        'nl' : 'Holandés',
        'ar' : 'Árabe',
        'da' : 'Danés',
        'zh' : 'Chino',
        'ko' : 'Coreano',
        'he' : 'Hebreo',
        'ja' : 'Japonés',
        'ru' : 'Ruso',
        'pl' : 'Polaco',
        'se' : 'Sueco',
        'ro' : 'Rumano',
        'cat' : 'Catalán',
        'hu' : 'Húngaro',
        'br' : 'Portugues de Brasil',
        'fi' : 'Finlandés',
        'tr' : 'Turco',
        'fa' : 'Persa',
    };
}

export default {
    getLanguages
};
